import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import LoginPage from "../assets/images/Loginpage.jpg";
import { useNavigate } from "react-router-dom";
import { NotificationManager } from 'react-notifications'
import { data } from "autoprefixer";
import { isTokenExpired, logoutUser } from "../utils/auth";
import { useCart } from "../context/CartContext";

const Login = () => {


  const [isLogin, setIsLogin] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirm_password: "",
    mobile: "",
  });


  const [otp, setOtp] = useState(Array(6).fill(""));
  const [step, setStep] = useState("form");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);

  const [resetData, setResetData] = useState({
    email: "",
    otp_code: "",
    new_password: "",
    confirm_password: "",
  });
  const [registerError, setRegisterError] = useState("");
  const [resetError, setResetError] = useState("");

  const { setCartCount } = useCart();
  const navigate = useNavigate();

  useEffect(() => {

    const token = localStorage.getItem("token");
    if (token) {
      if (isTokenExpired(token)) {
        logoutUser();
      } else {
        setIsAuthenticated(true);
        navigate("/")
      }
    }
  }, [navigate]);




  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleResetChange = (e) => {
    setResetData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  // REGISTER
  const handleRegister = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirm_password) {
      setRegisterError("Passwords do not match")
      return
    }
    setRegisterError("")
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/auth/create-user/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          role: "User",
        }),
      });
      console.log("res", res)

      const data = await res.json();
      // console.log("data", data)
      if (res.ok) {
        NotificationManager.success(data.message || "Please check your email for OTP.", "User created!");
        setStep("otp");
        console.log("res", res)
      } else {
        // alert(data.message || "Registration failed");
        NotificationManager.error(data.error || "Registration failed", "Error");
      }
    } catch (err) {
      // console.error(err);

      NotificationManager.error(data.error || "Error creating user", "Error");
    }
    setLoading(false);
  };

  // VERIFY OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/auth/verify-otp/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email,
          otp_code: Number(otp.join("")),
        }),
      });


      const data = await res.json();
      if (res.ok) {
        // alert("OTP Verified! You can now login.");
        NotificationManager.success(data.message || "You can now login.", "OTP Verified!");
        setIsLogin(true);
        setStep("form");
      } else {
        // alert(data.message || "Invalid OTP");
        NotificationManager.error(data.error || "Invalid OTP", "Error");
      }
    } catch (err) {
      console.error(err);
      // alert("Error verifying OTP");
      NotificationManager.error(data.error || "Error verifying OTP", "Error");
    }
    setLoading(false);
  };

  // RESEND OTP
  const handleResendOtp = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/auth/resend-otp/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email }),
      });

      const data = await res.json();
      if (res.ok) {
        NotificationManager.success(data.message || "OTP resent! Please check your email.");
      } else {
        NotificationManager.error(data.error || "Failed to resend OTP");
      }
    } catch (err) {
      console.error(err);
      NotificationManager.error(data.error || "Error resending OTP");
    }
    setLoading(false);
  };

  // LOGIN
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/auth/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          identifier: formData.username || formData.email || formData.mobile,
          password: formData.password,
        }),
      });

      const data = await res.json();
      console.log("login response-----", data)
      if (res.ok) {
        // alert("Login successful!");
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("username", data.user.username)
        localStorage.setItem("user", JSON.stringify(data.user));
        

           const managementRoles = data.user.roles.filter(role =>
        role.includes("Management") || role === "Super Admin Access"
    );

    localStorage.setItem("roles", JSON.stringify(managementRoles));
        

        if (data.user.cart_count > 0) {
          const cartItems = Array(data.user.cart_count).fill({});
          setCartCount(cartItems);
        } else {
          setCartCount([])
        }
        NotificationManager.success(data.message || "Login successful!", "Welcome");
        navigate("/");

        // alert(data.message || "Login failed");
      } else {
        NotificationManager.error(data.error || "Login failed");
      }
    } catch (err) {
      console.error(err);
      // alert("Error logging in");
      NotificationManager.error(data.error || "Error logging in", "Error");
    }
    setLoading(false);
  };

  // FORGOT PASSWORD
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/auth/forgot-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: resetData.email }),
      });

      const data = await res.json();
      if (res.ok) {
        NotificationManager.success("OTP sent to your email.");
        setStep("reset");
      } else {
        NotificationManager.error(data.error || "Failed to send OTP");
      }
    } catch (err) {
      NotificationManager.error(data.error || "Error sending forgot password request");
    }
    setLoading(false);
  };

  // RESET PASSWORD
  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (resetData.new_password !== resetData.confirm_password) {
      setResetError("Passwords do not match");
      return;
    }
    setResetError("")

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/auth/reset-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(resetData),
      });

      const data = await res.json();
      if (res.ok) {
        NotificationManager.success(data.message || "Password reset successful! Please login.");
        setStep("form");
        setIsLogin(true);
      } else {
        NotificationManager.error(data.error || "Failed to reset password");
      }
    } catch (err) {
      NotificationManager.error(data.error || "Error resetting password");
    }
    setLoading(false);
  };

  return (

    <div className="main">
      <div
        className="base d-flex flex-column"
        style={{
          backgroundImage: `url(${LoginPage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
        }}
      >
        {/* Navbar */}
        <div className="child-nav">
          <Navbar />
        </div>

        {/* Centered Auth Box */}
        <div className="container d-flex justify-content-center align-items-center flex-fill">
          <div
            className="p-4 p-md-5 w-100 shadow-lg text-dark"
            style={{
              maxWidth: "700px",
              width: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              borderRadius: "15px",
              backdropFilter: "blur(10px)",
            }}
          >
            {/* Toggle Buttons */}


            {step === "form" && (
              <div className="d-flex justify-content-center mb-4 ">
                {isLogin ? (
                  // Show only Register button when on Login page
                  <button className="btn border-0" onClick={() => setIsLogin(false)}>
                    Don’t have an account? Register
                  </button>
                ) : (
                  // Show only Login button when on Register page
                  <button className="btn border-0" onClick={() => setIsLogin(true)}>
                    Already have an account? Login
                  </button>
                )}
              </div>
            )}
            {/* forms */}
            <div className="" row>
              <div className="col-12">


                {isLogin && step === "form" && (
                  <>
                    {/* LOGIN FORM */}
                    <h2 className="fw-bold mb-3 text-center">Welcome Back</h2>
                    <form onSubmit={handleLogin}>
                      {/* Email/Username */}
                      <div className="mb-3">
                        <label className="form-label">Email / Username / Mobile</label>
                        <input
                          type="text"
                          name="username"
                          className="form-control"
                          // placeholder="Enter email or username"
                          value={formData.username}
                          onChange={handleChange}
                        />
                      </div>

                      {/* Password */}
                      <div className="mb-3 position-relative">
                        <label className="form-label">Password</label>
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="form-control"
                          // placeholder="Enter your password"
                          value={formData.password}
                          onChange={handleChange}
                        />

                        <i
                          className={`bi ${showPassword ? "bi-eye" : " bi-eye-slash"} position-absolute mt-3`}
                          onClick={() => setShowPassword(!showPassword)}
                          style={{

                            top: "50%",
                            right: "15px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "#6c757d",
                          }}
                        ></i>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100 mt-3"
                        disabled={loading}
                      >
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </form>

                    {/* Forgot password */}
                    <p className="text-center mt-3">
                      <button
                        type="button"
                        className="btn btn-link text-decoration-underline"
                        onClick={() => setStep("forgot")}
                      >
                        Forgot password?
                      </button>
                    </p>
                  </>
                )}

                {/* REGISTER FORM */}
                {!isLogin && step === "form" && (
                  <>
                    <h2 className="fw-bold mb-3 text-center">Create Account</h2>
                    <form onSubmit={handleRegister}>
                      {/* Name */}
                      <div className="row">
                        <div className=" col-md-6 mb-3">
                          <label className="form-label">Username</label>
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            // placeholder="Enter username"
                            value={formData.username}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Email */}
                        <div className=" col-md-6 mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            // placeholder="Enter your email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* Mobile */}
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Mobile</label>
                          <input
                            type="text"
                            name="mobile"
                            className="form-control"
                            // placeholder="Enter your mobile number"
                            value={formData.mobile}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Password */}
                        <div className="col-md-6 mb-3 position-relative">
                          <label className="form-label">Password</label>
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className="form-control"
                            // placeholder="Enter your password"
                            value={formData.password}
                            onChange={handleChange}
                          />
                          <i
                            className={`bi ${showPassword ? "bi-eye " : "bi-eye-slash"} position-absolute mt-3 mr-2`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              top: "50%",
                              right: "15px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              fontSize: "20px",
                              color: "#6c757d",
                            }}
                          ></i>
                        </div>
                      </div>

                      {/* Confirm Password */}
                      <div className="mb-3">
                        <label className="form-label">Confirm Password</label>
                        <input
                          type="password"
                          name="confirm_password"
                          className="form-control"
                          // placeholder="Confirm your password"
                          value={formData.confirm_password}
                          onChange={handleChange}
                        />
                        {registerError && <p className="text-danger small">{registerError}</p>}
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Registering..." : "Register"}
                      </button>
                    </form>
                  </>
                )}
                {/* OTP VERIFICATION */}
                {step === "otp" && (
                  <>

                    <h2 className="fw-bold mb-3 text-center">Verify OTP</h2>
                    <p className="text-center mb-4">
                      Please enter the code we just sent to <br />
                      <span className="fw-bold">{formData.email}</span>
                    </p>
                    <form onSubmit={handleVerifyOtp} className="text-center">
                      <div className="d-flex justify-content-center flex-nowrap gap-2 mb-4"
                      // style={{ maxWidth: "100%", overflow: "hidden" }}
                      >
                        {otp.map((digit, index) => (


                          <input
                            key={index}
                            type="text"
                            inputMode="numeric"
                            maxLength="1"
                            className="form-control text-center"
                            // style={{ width: "60px", height: "60px", fontSize: "24px" }}
                            // style={{
                            //   width: window.innerWidth < 400 ? "40px" : window.innerWidth < 576 ? "50px" : "60px",
                            //   height: window.innerWidth < 400 ? "45px" : window.innerWidth < 576 ? "55px" : "60px",
                            //   fontSize: window.innerWidth < 400 ? "18px" : window.innerWidth < 576 ? "20px" : "24px",
                            //    MozAppearance: "textfield",
                            // }}

                            style={{
                              flex: "1 0 12%", 
                              maxWidth: "50px",
                              minWidth: "35px", 
                              height: "50px",
                              fontSize: "20px",
                              MozAppearance: "textfield",
                            }}
                            // placeholder="Enter OTP"
                            value={digit}
                            onChange={(e) => {
                              let value = e.target.value.replace(/[^0-9]/g, "");
                              let newOtp = [...otp];
                              newOtp[index] = value;
                              setOtp(newOtp);

                              if (value && e.target.nextSibling) {
                                e.target.nextSibling.focus()
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Backspace" && !otp[index] && e.target.previousSibling) {
                                e.target.previousSibling.focus();
                              }
                            }}
                          />
                        ))}
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Verifying..." : "Verify OTP"}
                      </button>
                      {/*RESEND OTP*/}
                      <p className="small">
                        Didn’t receive OTP?{" "}
                        <button
                          type="button"
                          className="border border-0 mt-2 bg-transparent text-primary text-decoration-underline"
                          onClick={handleResendOtp}
                          disabled={loading}>
                          Resend OTP
                        </button>
                      </p>

                    </form>
                  </>
                )}
                {/* FORGOT PASSWORD */}
                {step === "forgot" && (
                  <>
                    <h2 className="fw-bold mb-3 text-center">Forgot Password</h2>
                    <form onSubmit={handleForgotPassword}>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          // placeholder="Enter your email"
                          value={resetData.email}
                          onChange={handleResetChange}
                        />
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Sending OTP..." : "Send OTP"}
                      </button>
                    </form>
                  </>
                )}

                {/* RESET PASSWORD */}
                {step === "reset" && (
                  <>
                    <h2 className="fw-bold mb-3 text-center">Reset Password</h2>
                    <form onSubmit={handleResetPassword}>
                      <div className="mb-3">
                        <label className="form-label">OTP</label>
                        <input
                          type="text"
                          name="otp_code"
                          className="form-control"
                          // placeholder="Enter OTP"
                          value={resetData.otp_code}
                          onChange={handleResetChange}
                        />
                      </div>

                      <div className="mb-3 position-relative">
                        <label className="form-label">New Password</label>
                        <input
                          type={showResetPassword ? "text" : "password"}
                          name="new_password"
                          className="form-control"
                          // placeholder="Enter new password"
                          value={resetData.new_password}
                          onChange={handleResetChange}
                        />
                        <i
                          className={`bi ${showResetPassword ? "bi-eye " : "bi-eye-slash"} position-absolute mt-3`}
                          onClick={() => setShowResetPassword(!showResetPassword)}
                          style={{
                            top: "50%",
                            right: "15px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "#6c757d",
                          }}
                        ></i>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Confirm Password</label>
                        <input
                          type="password"
                          name="confirm_password"
                          className="form-control"
                          // placeholder="Confirm new password"
                          value={resetData.confirm_password}
                          onChange={handleResetChange}
                        />
                        {resetError && <p className="text-danger small">{resetError}</p>}
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Resetting..." : "Reset Password"}
                      </button>
                    </form>
                  </>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Login;
